// tool;s
import React, {useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from "react-router-dom"

// utils
import  * as appUtils from '../../../utils/applications/appGenerator';
import { mountApplication } from '../../../store/calls/applicationData';


// components
import FormFlowWrapper from '../../theme/wrappers/FormFlowWrapper';

// every application needs:

// one - a project id Does it though???
// two - an application template
// three - an associated User.


const DEFAULT_PPA_TEMPLATE_ID = 63;

function PPAApplication({projectLeadId=0, applicationTemplateId = 63}) {
 

    let { project_id } = useParams();
    let history = useHistory;

    useEffect(() => {
        mountApplication({project_id})
            .then((data) => {
                console.log("MOUNT RESULT", data)
            })
    }, [])
    

    
    return (
        <FormFlowWrapper>
            
            <div>Hello</div>
        </FormFlowWrapper>
         
    )    

}


export default PPAApplication;